import React from "react";
import { Row, Col, Form, Spinner } from "react-bootstrap";
import { useState, useEffect } from "react";
import { checkPermissionStatus } from "helpers/utils";
import api from "../../api";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
const ImportResumeUser = () => {
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null); // State to store the selected file
  const [resumeGenerated, setResumeGenerated] = useState(false); // Track resume generation
  const [generatedResumeUrl, setGeneratedResumeUrl] = useState(""); // URL of generated resume
  const history = useHistory();

  useEffect(() => {
    document.title = "NeuroTal - Import Resumes";
  }, []);

  const handleClick = () => {
    history.goBack(); // Navigate to the previous page
  };
  // Handle file upload and save the file in the state
  const handleFileChange = event => {
    const file = event.target.files[0];
    setSelectedFile(file); // Save the file to state
  };

  // Handle the actual file upload and API request
  const handleFileUpload = async () => {
    if (!selectedFile) {
      alert("Please select a file first.");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("resume", selectedFile); // Use the selected file

      // Perform API request using fetch
      const response = await fetch(
        "https://kfc.itsneobot.com:8080/cv/generation",
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        const result = await response.json();
        const fileName = result.file; // Assuming the response contains the file name
        setGeneratedResumeUrl(fileName); // Save generated resume URL
        setResumeGenerated(true);
        alert("Resume generated successfully!");
        // Call the download function after generation
        handleDownloadResume(fileName);

        // Optionally save the resume filename to the database
        await api.post(
          `${process.env.REACT_APP_API_URL}/jobapply/admin/update-resume`,
          {
            user_id: "USER_ID", // Replace with actual user ID
            resume_filename: fileName,
            isResumeBuilt: 1,
          }
        );
      } else {
        alert("Failed to generate the resume.");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("An error occurred while uploading the resume.");
    } finally {
      setLoading(false); // Set loading to false when process ends
    }
  };

  // Function to handle resume download
  const handleDownloadResume = fileName => {
    const downloadUrl = fileName || generatedResumeUrl; // Use the existing or passed resume URL
    if (downloadUrl) {
      // Construct the complete S3 URL using the generatedResumeUrl
      const resumeDownloadUrl = `https://s3.ap-south-1.amazonaws.com/neurotal-3.0-dev/CV_Format_Resumes/${downloadUrl}`;

      const link = document.createElement("a");
      link.href = resumeDownloadUrl; // S3 URL of the resume
      link.target = "_blank"; // Open in a new tab if needed

      // Extract the filename from the URL
      const file = resumeDownloadUrl.split("/").pop(); // Gets the last part of the URL
      link.download = file; // Set the download attribute

      // Append the link to the document and trigger a click
      document.body.appendChild(link);
      link.click();

      // Clean up by removing the link
      document.body.removeChild(link);
    } else {
      alert("No resume generated. Please build the resume first.");
    }
  };
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
  return (
    <>
      <div className="pending-list-page feedbacks">
        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center py-2 pt-0 depart-content">
            <Col lg="6" md="6">
              <h5 className="text-uppercase heading-one">
                <img
                  src={arrow_btn}
                  alt="arrow_btn"
                  className="arrow-btn"
                  onClick={handleClick}
                />
                CV Build
              </h5>
            </Col>
          </Row>
        </div>

        <Col lg={12}>
          <div className="outerTab-box-wrapper below-vacancy">
            <div className="cards-section  cadidate-details import-resume-card">
              <h4>User Resume Upload</h4>
              <div className="serach-bar-top upload-flies-create w-100">
                <h4>Upload CV/Resume</h4>
                {checkPermissionStatus("import-resume", "create") && (
                  <Form.Group className="floating-label">
                    <label className="btn btn-sm btn-primary mb-0 d-flex">
                      {loading && <Spinner size={"sm"} className="mx-2" />}
                      Choose File
                      <input
                        type="file"
                        onChange={e => {
                          if (!loading) {
                            handleFileChange(e);
                          }
                        }}
                        accept=".pdf,.docx,.doc"
                        style={{ display: "none" }}
                        disabled={loading}
                      />
                    </label>
                  </Form.Group>
                )}
                {/* Display selected file name */}
                {selectedFile && (
                  <div className="selected-file-name mt-3 text-center mt-3">
                    <p>
                      <strong>Selected File:</strong> {selectedFile.name}
                    </p>
                  </div>
                )}
                <div className="upload-files-po">
                  <p>"Only PDF file type allowed less than 10MB"</p>
                </div>
                {/* Submit and Upload button */}
                <div className="text-center mt-3">
                  <button
                    className="btn btn-sm btn-primary mt-3"
                    onClick={handleFileUpload}
                    disabled={loading}
                  >
                    {loading ? "Uploading..." : "Submit & Generate CV"}
                  </button>
                </div>

                {/* Display Download Resume button if resume is generated */}
                {resumeGenerated && (
                  <div className="text-center mt-3">
                    <button
                      className="btn btn-sm btn-primary mt-3"
                      onClick={() => handleDownloadResume()}
                    >
                      Download Resume
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Col>
      </div>
    </>
  );
};

export default ImportResumeUser;
